import React from 'react';
import { 
  Package, 
  Truck, 
  Globe2, 
  ClipboardCheck, 
  Award, 
  MapPin 
} from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Services = () => {
  const { t } = useLanguage();

  const services = [
    {
      icon: Package,
      title: t.services.import.title,
      description: t.services.import.description
    },
    {
      icon: Globe2,
      title: t.services.export.title,
      description: t.services.export.description
    },
    {
      icon: Truck,
      title: t.services.distribution.title,
      description: t.services.distribution.description
    },
    {
      icon: ClipboardCheck,
      title: t.services.consulting.title,
      description: t.services.consulting.description
    },
    {
      icon: Award,
      title: t.services.quality.title,
      description: t.services.quality.description
    },
    {
      icon: MapPin,
      title: t.services.logistics.title,
      description: t.services.logistics.description
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center">
        <div
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://images.pexels.com/photos/30520745/pexels-photo-30520745.jpeg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-black opacity-60"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <h1 className="text-5xl font-bold mb-4">{t.services.hero.title}</h1>
          <p className="text-xl text-gray-200">{t.services.hero.subtitle}</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 p-8 rounded-2xl hover:shadow-xl transition-shadow"
              >
                <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <service.icon className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            {t.home.hero.cta}
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            {t.services.hero.subtitle}
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors"
          >
            {t.nav.contact}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;
